'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;

exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
